export const ID_PROOFING_ERROR_STORAGE_KEY = "idproofing_error";
